import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCloudSolutionsPath } from "@core/schema/paths/getCloudSolutionsPath.js";

export function getTransportWhyFastest(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Neděláme krabicová řešení",
			desc: "Šablony a krabicová řešení necháváme na jiných. Přepravním i dalším firmám vytváříme software 100% na míru podle jejich potřeb.",
		},
		{
			title: "Začínáme tam, kde jiní končí",
			desc: "Často dokážeme najít řešení i na zdánlivě neřešitelný problém. Máte konkrétní představu, ale nevíte, jestli půjde realizovat? Uděláme pro to maximum.",
		},

		{
			title: "Dlouholeté zkušenosti s přepravou",
			desc: "Již řadu let dodáváme software a systémy pro logistické firmy, spediční podniky i dopravce, takže dobře známe specifické potřeby tohoto oboru.",
		},
		{
			title: "Vyvíjíme na cloudu",
			desc: `Specializujeme se na [${getCloudSolutionsPath(tenant)}][[cloudová řešení]], tím vám ušetříme peníze za servery, které byste jinak museli provozovat a starat se o ně.`,
		},
		{
			title: "Podpora a snadné škálování",
			desc: "Po celou dobu provozování systémů je klientům k ruce naše specializovaná podpora. Jakýkoliv software můžeme do budoucna snadno upravit a přizpůsobit.",
		},
	];
}
